import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Policies from "../../Policies/Policies";

export default function SidebarUser() {
  const [user, setUser] = useState();
  const { currentUserProfile } = useSelector((state) => state.Profile);

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("user")));
  }, [currentUserProfile]);

  return (
    <div className="sidebar-profile sticky-top">
      <div className="d-flex align-items-center justify-content-between">
        <img src={user?.profile_image || "/images/picon.jpg"} alt="profile" />
        <div className="profile-desc">
          <p className="name mb-0">{user?.full_name || "Admin User"}</p>
          <p className="designation mb-0">
            {Policies.SubAdminPolicy?.view ? "Super Admin" : "Admin"}
          </p>
        </div>
      </div>
    </div>
  );
}
